const home = {
  hero_badge: 'منصة السياحة الصحية في تركيا',
  hero_title_1: 'استعد',
  hero_title_2: 'صحتك',
  hero_title_3: 'في تركيا',
  hero_subtitle: 'اكتشف المؤسسات الصحية المعتمدة في تركيا للمرضى القادمين من الخارج. خطط لرحلتك بنفسك أو اترك كل التنظيم لوكالة وسيطة.',
  hero_stat_institutions: 'مؤسسة معتمدة',
  hero_stat_patients: 'مريض سعيد',
  hero_stat_doctors: 'طبيب متخصص',
  hero_stat_countries: 'دولة',
  hero_accreditation_label: 'الاعتماد:',
  hero_search_title: 'البحث عن علاج',
  hero_step1_label: 'نوع العلاج',
  hero_step1_placeholder: 'اكتب أو اختر العلاج...',
  hero_step2_label: 'تفضيل التنظيم',
  hero_self_organize: 'يمكنني تنظيم الرحلة بنفسي',
  hero_agency_organize: 'لتنظم وكالة مستشفاي ورحلتي',
  hero_step3_agency: 'وكالة وسيطة',
  hero_step3_institution: 'مؤسسة صحية',
  hero_step3_optional: '(اختياري)',
  hero_all_agencies: 'عرض جميع الوكالات',
  hero_all_institutions: 'عرض جميع المؤسسات',
  hero_city_label: 'المدينة',
  hero_all_cities: 'جميع المدن',
  hero_search_agencies: 'استكشاف الوكالات',
  hero_search_institutions: 'استكشاف المؤسسات الصحية',
  hero_trust_note: 'جميع المؤسسات معتمدة من وزارة الصحة في جمهورية تركيا',

  steps_title: '3 خطوات لاستخدام المنصة',
  steps_subtitle: 'أصبح إيجاد المؤسسة الصحية المناسبة أسهل بكثير',
  step1_number: 'الخطوة 1',
  step1_title: 'التسجيل مجاناً',
  step1_desc: 'سجل مجاناً في المنصة واحصل على وصول فوري لجميع الميزات',
  step2_number: 'الخطوة 2',
  step2_title: 'تصفح المؤسسات',
  step2_desc: 'قارن المؤسسات الصحية المعتمدة، راجع الأطباء والخدمات',
  step3_number: 'الخطوة 3',
  step3_title: 'إرسال طلب معاودة الاتصال',
  step3_desc: 'أرسل طلب معاودة اتصال للمؤسسة المختارة، سيتصلون بك بلغتك',

  treatment_badge: 'مجالات العلاج',
  treatment_title: 'العلاجات الأكثر',
  treatment_title_highlight: 'شعبية في تركيا',
  treatment_subtitle: 'يختار آلاف المرضى الدوليين تركيا كل عام. اكتشف المؤسسات المعتمدة في مجالات العلاج أدناه.',
  treatment_view_institutions: 'عرض المؤسسات',
  treatment_view_all: 'عرض جميع مجالات العلاج',

  institutions_title: 'المؤسسات',
  institutions_title_highlight: 'الصحية',
  institutions_subtitle: 'ابحث عن الأنسب بين المؤسسات الصحية المعتمدة',
  institutions_view_all: 'عرض جميع المؤسسات',
  institutions_empty: 'لا توجد مؤسسات معتمدة بعد.',
  agencies_badge: 'التنظيم وخدمات السفر',
  agencies_title: 'وكالات',
  agencies_title_highlight: 'السياحة الصحية',
  agencies_subtitle: 'وكالات تنظم خدمتك الصحية مع احتياجات السفر والإقامة والسياحة',
  agencies_view_all: 'عرض جميع الوكالات',
  agencies_empty_title: 'لا توجد وكالات بعد',
  agencies_empty_desc: 'ستُدرج الوكالات قريباً.',
  agency_label: 'وكالة',
  consultation_available: 'يمكن إرسال طلب استشارة',
  service_flight: 'طيران ونقل',
  service_hotel: 'حجز فندق',
  service_tour: 'جولة سياحية',
  service_translation: 'ترجمة',
  service_vip: 'استقبال VIP',

  why_title: 'لماذا',
  why_title_highlight: 'تختارنا؟',
  why_subtitle: 'دليلك الموثوق للمرضى الدوليين الباحثين عن رعاية صحية في تركيا',
  why_stat_institutions: 'مؤسسة معتمدة',
  why_stat_treatments: 'مجال علاج',
  why_stat_countries: 'دولة',
  why_stat_satisfaction: 'رضا المرضى',
  why_feature1_title: 'مؤسسات معتمدة',
  why_feature1_desc: 'جميع المؤسسات الصحية على المنصة مؤسسات موثقة باعتماد JCI أو ISO أو وزارة الصحة التركية.',
  why_feature2_title: 'دعم متعدد اللغات',
  why_feature2_desc: 'صفّ بسهولة المؤسسات التي تقدم دعم التواصل بالعربية والإنجليزية والروسية وغيرها.',
  why_feature3_title: 'مقارنة تفصيلية',
  why_feature3_desc: 'قارن المؤسسات جنباً إلى جنب بناءً على خدماتها وأطبائها ومواقعها وتقييمات المرضى.',
  why_feature4_title: 'طلب معاودة الاتصال',
  why_feature4_desc: 'أرسل طلب معاودة اتصال مباشرة للمؤسسة التي تعجبك. ستتصل بك المؤسسة بدعم لغوي.',
  why_feature5_title: 'تكلفة معقولة',
  why_feature5_desc: 'احصل على رعاية صحية عالمية المستوى بأسعار أقل بـ 50-70% مقارنة بأوروبا والولايات المتحدة.',
  why_feature6_title: 'الموقع والمواصلات',
  why_feature6_desc: 'اكتشف المؤسسات في جميع مدن تركيا، خاصة إسطنبول وأنقرة وإزمير وأنطاليا.',

  inst_approved_badge: 'معتمد',
  inst_explore: 'استكشاف',
  inst_doctor_count: '{{count}} طبيب',
  inst_no_approved: 'لا توجد مؤسسات معتمدة بعد.',
  agencies_service_badge: 'وكالة سياحة صحية',
  agencies_consult: 'يمكن إرسال طلب استشارة',
  agencies_explore: 'استكشاف',

  process_badge: 'خطوة بخطوة',
  process_title: 'عملية',
  process_title_highlight: 'أطفال الأنابيب',
  process_subtitle: 'تعرف على كل مرحلة من مراحل علاج أطفال الأنابيب بطريقة مفهومة',
  process_step_label: 'الخطوة {{num}}',
  process_step1_title: 'التقييم الأولي',
  process_step1_desc: 'يتم إنشاء خطة علاج مع فحص مفصل واختبارات هرمونية وموجات فوق صوتية.',
  process_step2_title: 'تحفيز المبيض',
  process_step2_desc: 'يتم تحفيز المبايض بأدوية هرمونية ومراقبة تطور البويضات.',
  process_step3_title: 'استرداد البويضات',
  process_step3_desc: 'يتم جمع البويضات الناضجة تحت تخدير خفيف.',
  process_step4_title: 'الإخصاب',
  process_step4_desc: 'يتم دمج خلايا البويضة والحيوانات المنوية في بيئة مختبرية.',
  process_step5_title: 'تطور الجنين',
  process_step5_desc: 'يتم تطوير الأجنة المتكونة في المختبر لمدة 3-5 أيام.',
  process_step6_title: 'نقل الجنين',
  process_step6_desc: 'يتم وضع الجنين الأعلى جودة داخل الرحم وانتظار اختبار الحمل.',

  explore_badge: 'اكتشف تركيا',
  explore_title: 'تعرف على',
  explore_title_highlight: 'تركيا',
  explore_subtitle: 'لا تفوت فرصة استكشاف هذا البلد الجميل أثناء قدومك إلى تركيا للعلاج.',
  explore_destinations: 'الوجهات',
  explore_culture: 'الثقافة والحياة',
  explore_about_title: 'عن تركيا',
  explore_about_subtitle: 'المدن والوجهات والمعلومات العملية',
  explore_about_desc: 'شبه الجزيرة التاريخية في إسطنبول، وسواحل بحر إيجه في إزمير، والمياه الفيروزية في أنطاليا والمزيد. اكتشف أجمل وجهات تركيا.',
  explore_about_highlights: 'إسطنبول,إزمير,أنطاليا,كابادوكيا',
  explore_culture_title: 'الثقافة في تركيا',
  explore_culture_subtitle: 'آداب السلوك والمطبخ والتقاليد',
  explore_culture_desc: 'الضيافة التركية وثقافة الشاي والمطبخ اللذيذ والتقاليد الغنية. كل ما تحتاج معرفته قبل القدوم إلى تركيا.',
  explore_culture_highlights: 'المطبخ التركي,آداب السلوك,التقاليد,الحياة الاجتماعية',
  explore_cta: 'استكشاف',
  explore_stat1: '81 محافظة، وجهات لا تعد',
  explore_stat2: 'المطبخ التركي الغني',
  explore_stat3: '10,000 سنة من التاريخ',

  faq_badge: 'مكتبة المعرفة',
  faq_title: 'الأسئلة',
  faq_title_highlight: 'الشائعة',
  faq_subtitle: 'أسئلة فضولية حول عملية أطفال الأنابيب',
  faq_q1: 'ما هو علاج أطفال الأنابيب وكيف يعمل؟',
  faq_a1: 'أطفال الأنابيب (IVF) هو عملية دمج خلايا البويضة والحيوانات المنوية في بيئة مختبرية ووضع الجنين الناتج في رحم الأم. تتكون عملية العلاج من العلاج الهرموني واسترداد البويضات والإخصاب ونقل الجنين.',
  faq_q2: 'كم يستغرق علاج أطفال الأنابيب؟',
  faq_a2: 'تستغرق دورة علاج أطفال الأنابيب الواحدة في المتوسط 4-6 أسابيع. تشمل هذه الفترة التحضير والعلاج الهرموني واسترداد البويضات ونقل الجنين.',
  faq_q3: 'ما هو معدل نجاح علاج أطفال الأنابيب؟',
  faq_a3: 'يعتمد معدل النجاح على عوامل مثل العمر وجودة البويضات وجودة الحيوانات المنوية والحالة الصحية العامة. يبلغ معدل النجاح حوالي 40-50٪ للنساء دون سن 35 وينخفض مع التقدم في السن.',
  faq_q4: 'هل علاج أطفال الأنابيب مؤلم؟',
  faq_a4: 'معظم عملية العلاج غير مؤلمة. يتم إجراء استرداد البويضات تحت تخدير خفيف والانزعاج ضئيل. نقل الجنين إجراء غير مؤلم.',
  faq_q5: 'هل هناك حد عمري لعلاج أطفال الأنابيب؟',
  faq_a5: 'في تركيا، الحد العمري القانوني لعلاج أطفال الأنابيب هو 18-49 للنساء و18-60 للرجال. نظراً لانخفاض معدل النجاح مع التقدم في السن، فمن الأفضل البدء في العلاج خاصة قبل سن 35.',
  faq_q6: 'ما هي تكلفة علاج أطفال الأنابيب؟',
  faq_a6: 'تتفاوت التكلفة حسب المركز المختار وبروتوكول العلاج واستخدام الأدوية. في تركيا، يتراوح المتوسط بين 15,000-30,000 ليرة تركية. قد توفر بعض التأمينات الصحية الخاصة تغطية جزئية.',

  // خدمات العلاج
  treat_sac_ekimi_title: 'زراعة الشعر',
  treat_sac_ekimi_subtitle: 'تقنية FUE / DHI',
  treat_sac_ekimi_desc: 'من أكثر خدمات السياحة الصحية طلباً في العالم. نتائج دائمة وطبيعية.',
  treat_sac_ekimi_tag: 'الأكثر شعبية',
  treat_dis_tedavisi_title: 'علاج الأسنان',
  treat_dis_tedavisi_subtitle: 'زراعة / قشرة / زيركونيا',
  treat_dis_tedavisi_desc: 'تركيا هي الوجهة الأكثر تفضيلاً في أوروبا لطب الأسنان التجميلي وعلاجات الزرع.',
  treat_dis_tedavisi_tag: 'مرغوب جداً',
  treat_goz_ameliyati_title: 'جراحة العيون',
  treat_goz_ameliyati_subtitle: 'LASIK / LASEK / عدسة',
  treat_goz_ameliyati_desc: 'حلول بصرية دائمة مع عيادات متخصصة في جراحة العين بالليزر والعدسات داخل العين.',
  treat_goz_ameliyati_tag: '',
  treat_estetik_cerrahi_title: 'الجراحة التجميلية',
  treat_estetik_cerrahi_subtitle: 'تجميل الأنف / شفط الدهون / BBL',
  treat_estetik_cerrahi_desc: 'عمليات آمنة وعالية الجودة مع متخصصين ذوي خبرة في الجراحة التجميلية.',
  treat_estetik_cerrahi_tag: 'طلب مرتفع',
  treat_ortopedi_title: 'العظام وجراحة الصدمات',
  treat_ortopedi_subtitle: 'الركبة / الورك / العمود الفقري',
  treat_ortopedi_desc: 'مراكز عظام متخصصة في استبدال المفاصل وجراحة العمود الفقري وإصابات الرياضة.',
  treat_ortopedi_tag: '',
  treat_tup_bebek_title: 'علاج أطفال الأنابيب',
  treat_tup_bebek_subtitle: 'IVF / ICSI / PGT',
  treat_tup_bebek_desc: 'حقق حلمك في تكوين أسرة مع مراكز أطفال الأنابيب المعتمدة في تركيا.',
  treat_tup_bebek_tag: '',
  treat_kardiyoloji_title: 'أمراض القلب',
  treat_kardiyoloji_subtitle: 'جراحة القلب / القسطرة',
  treat_kardiyoloji_desc: 'مراكز قلبية تقدم خدمات بمستوى عالمي في علاج أمراض القلب والأوعية الدموية.',
  treat_kardiyoloji_tag: '',
  treat_onkoloji_title: 'الأورام',
  treat_onkoloji_subtitle: 'علاج السرطان / العلاج الإشعاعي',
  treat_onkoloji_desc: 'مسيرة مليئة بالأمل مع مراكز الأورام التي تستخدم أحدث الأساليب في تشخيص السرطان وعلاجه.',
  treat_onkoloji_tag: '',
  treat_obezite_title: 'جراحة السمنة',
  treat_obezite_subtitle: 'تكميم المعدة / التحويل',
  treat_obezite_desc: 'انطلق نحو حياة صحية مع فرق متخصصة في جراحة السمنة والتمثيل الغذائي.',
  treat_obezite_tag: '',
  treat_checkup_title: 'فحص شامل',
  treat_checkup_subtitle: 'فحص صحي شامل',
  treat_checkup_desc: 'حافظ على صحتك مع باقات الكشف المبكر والفحص الصحي الشامل.',
  treat_checkup_tag: '',
  treat_noroloji_title: 'طب الأعصاب وجراحة المخ',
  treat_noroloji_subtitle: 'المخ / الجهاز العصبي',
  treat_noroloji_desc: 'علاج شامل مع مراكز متخصصة في الأمراض العصبية وجراحة المخ.',
  treat_noroloji_tag: '',
  treat_uroloji_title: 'المسالك البولية',
  treat_uroloji_subtitle: 'الكلى / المثانة / البروستاتا',
  treat_uroloji_desc: 'حلول آمنة مع عيادات متخصصة في تشخيص وعلاج أمراض المسالك البولية.',
  treat_uroloji_tag: '',
  treat_dermatoloji_title: 'الأمراض الجلدية',
  treat_dermatoloji_subtitle: 'الجلد / الليزر / التجميل',
  treat_dermatoloji_desc: 'بشرة صحية مع عيادات متخصصة في أمراض الجلد والطب الجلدي التجميلي.',
  treat_dermatoloji_tag: '',
  treat_fizik_tedavi_title: 'العلاج الطبيعي',
  treat_fizik_tedavi_subtitle: 'إعادة التأهيل / العلاج الفيزيائي',
  treat_fizik_tedavi_desc: 'تعافٍ سريع مع مراكز متخصصة في العلاج الطبيعي وإعادة التأهيل.',
  treat_fizik_tedavi_tag: '',
  treat_organ_nakli_title: 'زراعة الأعضاء',
  treat_organ_nakli_subtitle: 'الكلى / الكبد / القلب',
  treat_organ_nakli_desc: 'حياة جديدة مع مراكز زراعة الأعضاء ذات الخبرة.',
  treat_organ_nakli_tag: '',

  cta_badge: 'للمؤسسات',
  cta_title: 'أضف مؤسستك الصحية',
  cta_title_highlight: 'إلى المنصة',
  cta_subtitle: 'تواصل مع المزيد من المرضى. روّج لمؤسستك بعضوية مجانية أو Pro، واستقبل طلبات الاستشارة وعزز حضورك الإلكتروني.',
  cta_register: 'إنشاء حساب مؤسسة',
  cta_more_info: 'مزيد من المعلومات',
  cta_stat_centers: 'مركز مسجل',
  cta_stat_consultations: 'طلب استشارة',
  cta_stat_completed: 'استشارة مكتملة',
  cta_stat_cities: 'مدينة',
};

export default home;
